import React, { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { logoPng } from '../../config/assets';

const DOMAIN = 'tez-hop.uz';
const BASE_URL = process.env.REACT_APP_CLIENT_URL || window.location.origin;
const LOGO_URL = logoPng();

// ─── Скачать одну карточку как PNG ────────────────────────────
async function downloadQRCard({ slug, tableNumber, restaurantName }) {
  const url = `${BASE_URL}/menu/${slug}?table=${tableNumber}`;
  const W = 480; const H = 640;
  const canvas = document.createElement('canvas');
  canvas.width = W; canvas.height = H;
  const ctx = canvas.getContext('2d');

  ctx.fillStyle = '#FFFFFF';
  ctx.fillRect(0, 0, W, H);

  // ─── Чёрная шапка: лого + название + Стол N ───
  ctx.fillStyle = '#111111';
  if (ctx.roundRect) {
    ctx.beginPath();
    ctx.roundRect(0, 0, W, 88, 0);
    ctx.fill();
  } else {
    ctx.fillRect(0, 0, W, 88);
  }

  ctx.fillStyle = '#FFFFFF';
  ctx.font = 'bold 18px -apple-system, sans-serif';
  ctx.textAlign = 'left';
  ctx.fillText(restaurantName, 20, 38);

  ctx.font = '12px -apple-system, sans-serif';
  ctx.fillStyle = '#AAAAAA';
  ctx.fillText(`Стол №${tableNumber}`, 20, 56);

  // MENU по центру
  ctx.font = 'bold 24px -apple-system, sans-serif';
  ctx.fillStyle = '#FFFFFF';
  ctx.textAlign = 'center';
  ctx.fillText('MENU', W / 2, 52);

  // Круглый бейдж с номером справа
  ctx.fillStyle = '#FFFFFF';
  ctx.beginPath();
  ctx.arc(W - 36, 44, 24, 0, Math.PI * 2);
  ctx.fill();
  ctx.strokeStyle = '#333';
  ctx.lineWidth = 1;
  ctx.stroke();
  ctx.fillStyle = '#111111';
  ctx.font = 'bold 20px -apple-system, sans-serif';
  ctx.textAlign = 'center';
  ctx.fillText(String(tableNumber), W - 36, 50);

  // ─── Большой QR по центру ───
  const qrSize = Math.min(W - 80, 320);
  const qrX = (W - qrSize) / 2;
  const qrY = 120;

  const svgEl = document.querySelector(`#qr-svg-${tableNumber} svg`);
  if (svgEl) {
    const svgData = new XMLSerializer().serializeToString(svgEl);
    const blob = new Blob([svgData], { type: 'image/svg+xml' });
    const svgUrl = URL.createObjectURL(blob);
    await new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        ctx.drawImage(img, qrX, qrY, qrSize, qrSize);
        URL.revokeObjectURL(svgUrl);
        resolve();
      };
      img.src = svgUrl;
    });
  } else {
    const QR = await import('qrcode');
    const qrCanvas = document.createElement('canvas');
    await QR.toCanvas(qrCanvas, url, { width: qrSize, margin: 2 });
    ctx.drawImage(qrCanvas, qrX, qrY, qrSize, qrSize);
  }

  // ─── Футер: лого + tez-hop.uz по центру ───
  const footerY = H - 72;
  ctx.fillStyle = '#F7F7F7';
  ctx.fillRect(0, footerY, W, 72);

  const logoUrl = window.location.origin + LOGO_URL;
  const logoSize = 40;
  const footerCenterX = W / 2;
  await new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      ctx.drawImage(img, footerCenterX - logoSize - 8, footerY + 16, logoSize, logoSize);
      resolve();
    };
    img.onerror = () => resolve();
    img.src = logoUrl;
  });

  ctx.textAlign = 'center';
  ctx.fillStyle = '#333333';
  ctx.font = 'bold 14px -apple-system, sans-serif';
  ctx.fillText(DOMAIN, footerCenterX + 24, footerY + 42);

  const link = document.createElement('a');
  link.download = `QR_стол_${tableNumber}_${slug}.png`;
  link.href = canvas.toDataURL('image/png');
  link.click();
}

// ─── Одна QR-карточка (рекламная стойка) ──────────────────────
function TableQR({ slug, tableNumber, restaurantName }) {
  const [copied, setCopied] = useState(false);
  const url = `${BASE_URL}/menu/${slug}?table=${tableNumber}`;

  const handleCopy = () => {
    navigator.clipboard.writeText(url).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div style={{
      backgroundColor: '#fff',
      borderRadius: '20px',
      overflow: 'hidden',
      boxShadow: '0 4px 16px rgba(0,0,0,0.10)',
      display: 'flex',
      flexDirection: 'column',
    }}>
      {/* Чёрная шапка: название слева, MENU по центру, круглый бейдж справа */}
      <div style={{
        backgroundColor: '#111',
        padding: '14px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'relative',
      }}>
        <div>
          <div style={{ color: '#fff', fontWeight: '700', fontSize: '16px', lineHeight: 1.2 }}>
            {restaurantName}
          </div>
          <div style={{ color: '#AAA', fontSize: '12px', marginTop: '2px' }}>
            Стол №{tableNumber}
          </div>
        </div>
        <div style={{
          position: 'absolute', left: '50%', transform: 'translateX(-50%)',
          color: '#fff', fontWeight: '800', fontSize: '22px', letterSpacing: '0.05em',
        }}>
          MENU
        </div>
        <div style={{
          width: 48, height: 48,
          borderRadius: '50%',
          backgroundColor: '#fff',
          border: '1px solid #333',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: '20px', fontWeight: '800', color: '#111',
          flexShrink: 0,
        }}>
          {tableNumber}
        </div>
      </div>

      {/* Большой QR по центру */}
      <div
        id={`qr-svg-${tableNumber}`}
        style={{
          padding: '24px', display: 'flex', justifyContent: 'center', alignItems: 'center',
          backgroundColor: '#fff',
        }}
      >
        <QRCodeSVG
          value={url}
          size={180}
          bgColor="#FFFFFF"
          fgColor="#111111"
          level="M"
          includeMargin={false}
        />
      </div>

      {/* Футер: лого + tez-hop.uz по центру */}
      <div style={{
        backgroundColor: '#F7F7F7',
        padding: '14px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '10px',
        borderTop: '1px solid #EFEFEF',
      }}>
        <img
          src={LOGO_URL}
          alt=""
          style={{ width: 40, height: 40, objectFit: 'contain', flexShrink: 0 }}
        />
        <span style={{ fontSize: '14px', fontWeight: '700', color: '#333', fontFamily: "'Comfortaa', -apple-system, sans-serif" }}>
          {DOMAIN}
        </span>
      </div>

      <div style={{ display: 'flex', gap: '0', borderTop: '1px solid #F0F0F0' }}>
        <button
          type="button"
          onClick={() => downloadQRCard({ slug, tableNumber, restaurantName })}
          style={{
            flex: 1, padding: '11px 4px',
            border: 'none', borderRight: '1px solid #F0F0F0',
            backgroundColor: '#fff', color: '#111',
            fontSize: '13px', cursor: 'pointer',
            fontWeight: '600',
            borderBottomLeftRadius: '20px',
          }}
        >
          ⬇ PNG
        </button>
        <button
          type="button"
          onClick={handleCopy}
          style={{
            flex: 1, padding: '11px 4px',
            border: 'none',
            backgroundColor: copied ? '#E8F5E9' : '#fff',
            color: copied ? '#2E7D32' : '#555',
            fontSize: '13px', cursor: 'pointer',
            transition: 'all 0.2s',
            borderBottomRightRadius: '20px',
          }}
        >
          {copied ? '✅ Скопировано' : '🔗 Ссылка'}
        </button>
      </div>
    </div>
  );
}

// ─── Основной компонент QRTab ──────────────────────────────────
export default function QRTab({ restaurant }) {
  const slug = restaurant?.slug || 'demo';
  const name = restaurant?.name || 'Ресторан';

  const [tableCount, setTableCount] = useState(10);
  const [inputVal, setInputVal] = useState('10');
  const [customTable, setCustomTable] = useState('');
  const [customCopied, setCustomCopied] = useState(false);
  const [downloading, setDownloading] = useState(false);

  const tables = Array.from({ length: tableCount }, (_, i) => i + 1);

  const handleDownloadAll = async () => {
    setDownloading(true);
    for (let i = 0; i < tables.length; i++) {
      await new Promise(r => setTimeout(r, 400));
      await downloadQRCard({ slug, tableNumber: tables[i], restaurantName: name });
    }
    setDownloading(false);
  };

  const handleCustomCopy = () => {
    if (!customTable.trim()) return;
    const url = `${BASE_URL}/menu/${slug}?table=${encodeURIComponent(customTable.trim())}`;
    navigator.clipboard.writeText(url).then(() => {
      setCustomCopied(true);
      setTimeout(() => setCustomCopied(false), 2000);
    });
  };

  return (
    <div style={{ fontFamily: '-apple-system, sans-serif' }}>

      <div style={{
        backgroundColor: '#fff',
        borderRadius: '18px',
        padding: '16px',
        marginBottom: '14px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.07)',
      }}>
        <div style={{
          display: 'flex', alignItems: 'center', gap: '8px',
          marginBottom: '14px',
        }}>
          <span style={{ fontSize: '20px' }}>📱</span>
          <div>
            <div style={{ fontWeight: '700', fontSize: '16px' }}>QR-коды для столов</div>
            <div style={{ fontSize: '12px', color: '#999', marginTop: '1px' }}>{DOMAIN}</div>
          </div>
        </div>

        <div style={{ marginBottom: '12px' }}>
          <div style={{ fontSize: '12px', color: '#999', marginBottom: '6px', fontWeight: '600' }}>
            КОЛИЧЕСТВО СТОЛОВ
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <input
              type="number"
              min="1"
              max="50"
              value={inputVal}
              onChange={e => setInputVal(e.target.value)}
              onBlur={() => {
                const v = Math.min(50, Math.max(1, Number(inputVal) || 1));
                setTableCount(v); setInputVal(String(v));
              }}
              style={{
                width: '64px', padding: '8px',
                borderRadius: '10px', border: '1px solid #E0E0E0',
                fontSize: '16px', fontWeight: '700', textAlign: 'center', outline: 'none',
              }}
            />
            <div style={{ display: 'flex', gap: '6px' }}>
              {[5, 10, 15, 20].map(n => (
                <button
                  key={n}
                  type="button"
                  onClick={() => { setTableCount(n); setInputVal(String(n)); }}
                  style={{
                    padding: '8px 12px', borderRadius: '10px', border: 'none',
                    backgroundColor: tableCount === n ? '#111' : '#F0F0F0',
                    color: tableCount === n ? '#fff' : '#444',
                    fontSize: '13px', cursor: 'pointer', fontWeight: '600',
                    transition: 'all 0.15s',
                  }}
                >
                  {n}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div style={{
          backgroundColor: '#F8F8F8', borderRadius: '10px',
          padding: '10px 12px', fontSize: '12px', color: '#777',
          wordBreak: 'break-all', marginBottom: '12px',
          borderLeft: '3px solid #111',
        }}>
          🔗 {BASE_URL}/menu/<b style={{ color: '#111' }}>{slug}</b>?table=<b style={{ color: '#111' }}>N</b>
        </div>

        <div style={{ marginBottom: '4px' }}>
          <div style={{ fontSize: '12px', color: '#999', marginBottom: '6px', fontWeight: '600' }}>
            КАСТОМНОЕ НАЗВАНИЕ СТОЛА
          </div>
          <div style={{ display: 'flex', gap: '8px' }}>
            <input
              type="text"
              placeholder="VIP, Терраса, Кабинет..."
              value={customTable}
              onChange={e => setCustomTable(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && handleCustomCopy()}
              style={{
                flex: 1, padding: '9px 12px',
                borderRadius: '10px', border: '1px solid #E0E0E0',
                fontSize: '13px', outline: 'none',
              }}
            />
            <button
              type="button"
              onClick={handleCustomCopy}
              style={{
                padding: '9px 16px', borderRadius: '10px', border: 'none',
                backgroundColor: customCopied ? '#E8F5E9' : '#111',
                color: customCopied ? '#2E7D32' : '#fff',
                fontSize: '13px', cursor: 'pointer', whiteSpace: 'nowrap',
                fontWeight: '600', transition: 'all 0.2s',
              }}
            >
              {customCopied ? '✅' : '🔗 Копировать'}
            </button>
          </div>
        </div>
      </div>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: '12px',
        marginBottom: '14px',
      }}>
        {tables.map(n => (
          <TableQR key={n} slug={slug} tableNumber={n} restaurantName={name} />
        ))}
      </div>

      <button
        type="button"
        onClick={handleDownloadAll}
        disabled={downloading}
        style={{
          width: '100%', padding: '16px',
          borderRadius: '14px',
          border: downloading ? 'none' : '2px dashed #ccc',
          backgroundColor: downloading ? '#111' : 'transparent',
          color: downloading ? '#fff' : '#666',
          fontSize: '14px', fontWeight: '600', cursor: downloading ? 'not-allowed' : 'pointer',
          transition: 'all 0.2s',
        }}
      >
        {downloading
          ? `⏳ Скачиваем... (${tableCount} шт.)`
          : `⬇ Скачать все QR (${tableCount} шт.)`
        }
      </button>

      <div style={{
        textAlign: 'center', marginTop: '20px',
        fontSize: '12px', color: '#ccc',
      }}>
        Powered by <span style={{ color: '#111', fontWeight: '700' }}>{DOMAIN}</span>
      </div>
    </div>
  );
}
